export default __webpack_public_path__ + "static/media/icons-success.cddc0ceb.svg";